// extracted by extract-css-chunks-webpack-plugin
module.exports = {"relateVideo":"relateVideo-zxvrx6FW"};